import { render, staticRenderFns } from "./campaign-add.vue?vue&type=template&id=3dc23df6&"
import script from "./campaign-add.vue?vue&type=script&lang=js&"
export * from "./campaign-add.vue?vue&type=script&lang=js&"
import style0 from "./campaign-add.vue?vue&type=style&index=0&id=3dc23df6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports